export default "__VITE_ASSET__dac72f18__"